import React, { useEffect, useRef, useState } from 'react';
import { Table } from '../../components/Table/Table';
import { search_icon } from '../../assets/imgs';
import { Location_list } from '../../screens/redux/api/dummyJson';
import { useLazyCountryListQuery, useLazyLocationListQuery, useLocationListMutation } from '../../screens/redux/api/api';

const Country = ({list,setPageno,pagecount,setPagecount}) => {
    const [popup, setPopup] = useState(false);


    // const [locationListApi] = useLocationListMutation();



    // const locationLists = (page) => {
    //     const formdata = new FormData();
    //     formdata.append("type", 1)
    //     formdata.append("page", page)
    //     formdata.append("row", 10)
    //     locationListApi(formdata)
    //         .unwrap()
    //         .then((res) => {
    //             console.log("res", res);
    //             setList(res?.data);
    //             setPagecount({current_page:page,last_page:res?.data?.last_page})

    //         })
    //         .catch((err) => {
    //             console.log("err", err);
    //         })
    // }

    // useEffect(() => {
    //     locationLists(pageno);
    // }, [pageno]);

    const columns = React.useMemo(
        () => [
            {
                Header: "S.No",
                accessor: "",
                Cell: ({ value, row }) => {
                    return <p>{(row?.original?.current_page - 1) * 10 + row.index + 1}</p>;
                }
            },  
            // {
            //     Header: "Area",
            //     accessor: "area",
            //     Cell: ({ value, row }) => {
            //         return <p>{value}</p>;
            //     },
            // },
            // {
            //     Header: "City",
            //     accessor: "city",
            //     Cell: ({ value, row }) => {
            //         return <p>{value}</p>;
            //     },
            // },
            {
                Header: "Country",
                accessor: "name",
                Cell: ({ value, row }) => {
                    return <p>{value}</p>;
                },
            },
            // {
            //     Header: "State",
            //     accessor: "state",
            //     Cell: ({ value, row }) => {
            //         return <p>{value}</p>;
            //     },
            // },
            // {
            //     Header: "No of Property",
            //     accessor: "property",
            //     Cell: ({ value, row }) => {
            //         return <p>{value}</p>;
            //     },
            // },

        ],
        []
    );

    return (
        <div className="">
            <Table columns={columns} data={list} setPageno={setPageno} pagecount={pagecount} show={true} />

        </div >
    );
};
export default Country